import isChatroomDisabledByReed from './isChatroomDisabledByReed';

const rules = [
  isChatroomDisabledByReed,
];

const isGroupVideoCallDisabled = () => rules.some((rule) => rule());

export default isGroupVideoCallDisabled;
